import type { DataResponseBody, PageResponse, FileResponse } from "./common.types";

export type SiteRegion =
  | "SEOUL"
  | "GYEONGGI_INCHEON"
  | "GANGWON"
  | "CHUNGCHEONG"
  | "JEOLLA"
  | "GYEONGSANG"
  | "JEJU";

export const REGION_DISPLAY_NAMES: Record<SiteRegion, string> = {
  SEOUL: "서울",
  GYEONGGI_INCHEON: "경기인천",
  GANGWON: "강원도",
  CHUNGCHEONG: "충청도",
  JEOLLA: "전라도",
  GYEONGSANG: "경상도",
  JEJU: "제주도",
};

export interface Site {
  id: number;
  uuid?: string;
  name: string;
  region: SiteRegion;
  address?: string;
  lon?: number;
  lat?: number;
  location?: string;
  baseUrl?: string;
  constructionStartDate?: string;
  constructionEndDate?: string;
  description?: string;
  thumbnailImage?: FileResponse;
  /** 현장 도면. 지도에 얹는 용도이나 아직 화면에서 쓰지 않는다 (#229) */
  drawingFile?: FileResponse;
  modelFile?: FileResponse;
  modelHierarchy?: string | null;
}

export interface RegionResponse {
  name: SiteRegion;
  displayName: string;
}

export interface RegionGroup {
  region: SiteRegion;
  displayName: string;
  sites: Site[];
}

export type SitesResponse = DataResponseBody<PageResponse<Site>>;
export type SiteResponse = DataResponseBody<Site>;
export type RegionsResponse = DataResponseBody<RegionResponse[]>;

export interface GetSitesParams {
  region?: SiteRegion;
  page?: number;
  size?: number;
}
